<div class="cookies-banner" *ngIf="showBanner">
  <p>
    This website uses cookies to ensure you get the best experience. By continuing to use this site, you accept our use
    of cookies.
    <a [routerLink]="['/privacypolicy']">Learn more</a>
  </p>
  <button (click)="dismissBanner()">OK</button>
</div>